<script setup>
import { computed } from 'vue';
import { dateKeyInfo } from '@/js/core/utils/calendar-event-time';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const isDateOnly = computed(() => props.item.displayMode === 'date_only');
const startDateInfo = computed(() =>
  dateKeyInfo(props.item.startDate || props.item.start?.dateKey || '')
);
const endDateInfo = computed(() =>
  dateKeyInfo(props.item.endDate || props.item.end?.dateKey || '')
);
const hasDateRange = computed(
  () => endDateInfo.value.dateKey && endDateInfo.value.dateKey !== startDateInfo.value.dateKey
);
</script>

<template>
  <div
    v-if="isDateOnly && startDateInfo.dateKey"
    class="date_range same_year current_year same_month same_day same_meridian"
  >
    <time :datetime="startDateInfo.iso" class="start-time semantic en">
      <span class="day">{{ startDateInfo.dayName }}</span>
      <span class="sep">, </span><span class="month">{{ startDateInfo.monthName }}</span>
      <span class="sep">&nbsp;</span>
      <span class="day-num">{{ startDateInfo.dayNumber }}</span>
      <span class="sep">, </span>
      <span class="year">{{ startDateInfo.year }}</span>
    </time>

    <template v-if="hasDateRange">
      <span class="date_range_separator"> – </span>
      <time :datetime="endDateInfo.iso" class="end-time semantic en">
        <span class="day">{{ endDateInfo.dayName }}</span>
        <span class="sep">, </span><span class="month">{{ endDateInfo.monthName }}</span>
        <span class="sep">&nbsp;</span>
        <span class="day-num">{{ endDateInfo.dayNumber }}</span>
        <span class="sep">, </span>
        <span class="year">{{ endDateInfo.year }}</span>
      </time>
    </template>
  </div>

  <div
    v-else-if="item.start"
    class="date_range same_year current_year same_month same_day same_meridian"
  >
    <time :datetime="item.start.iso" class="start-time semantic en">
      <span class="day">{{ item.start.dayName }}</span>
      <span class="sep">, </span><span class="month">{{ item.start.monthName }}</span>
      <span class="sep">&nbsp;</span>
      <span class="day-num">{{ item.start.dayNumber }}</span>
      <span class="sep">, </span>
      <span class="year">{{ item.start.year }}</span>
      <span class="sep">, </span>

      <span class="hours">{{ item.start.hours }}</span>
      <template v-if="item.start.hasMinutes">
        <span class="sep">:</span><span class="minutes">{{ item.start.minutes }}</span>
      </template>
      <span class="sep-time"> </span>
      <span class="ampm">{{ item.start.ampm }}</span>
    </time>

    <template v-if="item.end">
      <span class="date_range_separator"> – </span>
      <time :datetime="item.end.iso" class="end-time semantic en">
        <span class="hours">{{ item.end.hours }}</span>
        <template v-if="item.end.hasMinutes">
          <span class="sep">:</span><span class="minutes">{{ item.end.minutes }}</span>
        </template>
        <span class="sep-time"> </span>
        <span class="ampm">{{ item.end.ampm }}</span>
      </time>
    </template>
    <div v-if="item.timezoneLabel" class="timezone-label">
      <span>{{ item.timezoneLabel }}</span>
    </div>
  </div>
</template>
